import { getBoundedValue } from 'utils/math/math.utils';
import { getValidMapPosition } from 'utils/maps/coordinate.utils';

export const parsePlaceCoordinates = (place) =>
  getValidMapPosition(
    place?.latitude ?? place?.geometry?.location?.lat,
    place?.longitude ?? place?.geometry?.location?.lng,
  );

const findSelectedPlace = (places, selectedPlaceId) => {
  if (!Array.isArray(places) || !places.length) {
    return null;
  }

  const normalizedSelectedPlaceId = `${selectedPlaceId ?? ''}`.trim();

  if (!normalizedSelectedPlaceId) {
    return null;
  }

  return (
    places.find((place) => {
      const placeId = place?.place_id ?? place?.id;

      return `${placeId ?? ''}`.trim() === normalizedSelectedPlaceId;
    }) ?? null
  );
};

const findHomePlace = (places) => {
  if (!Array.isArray(places) || !places.length) {
    return null;
  }

  return places.find((place) => place?.DefaultLocationUserHome) ?? places[0] ?? null;
};

export const resolvePreferredPlace = ({ places, selectedPlaceId }) =>
  findSelectedPlace(places, selectedPlaceId) ?? findHomePlace(places);

export function clampCoordinatesToBounds(coordinates, bounds) {
  if (!coordinates || !bounds) {
    return coordinates;
  }

  const [[south, west], [north, east]] = bounds;

  return [
    getBoundedValue(coordinates[0], south, north),
    getBoundedValue(coordinates[1], west, east),
  ];
}

export function parsePlaceViewportBounds(place) {
  const viewport = place?.place_data?.geometry?.viewport ?? place?.geometry?.viewport;
  const northeast = getValidMapPosition(viewport?.northeast?.lat, viewport?.northeast?.lng);
  const southwest = getValidMapPosition(viewport?.southwest?.lat, viewport?.southwest?.lng);

  if (!northeast || !southwest) return null;

  const [north, east] = northeast;
  const [south, west] = southwest;
  return south <= north && west <= east ? [southwest, northeast] : null;
}

export function clampViewportBounds(bounds, maxBounds) {
  if (!bounds) {
    return null;
  }

  return [
    clampCoordinatesToBounds(bounds[0], maxBounds),
    clampCoordinatesToBounds(bounds[1], maxBounds),
  ];
}
